
import { getTenantFromUrl } from './urlHelper';

export const hideHeader = (scrollPosition) => scrollPosition > 300;
export const getFullScreenPages = () => {
  const fullScreenPages = [
    '/callback',
    '/welcome',
    '/create-organization',
    '/organizations',
    '/organization-welcome',
    '/contact-us',
    '/login',
    '/logout',
    '/confirm-email',
    '/access-denied',
    '/deactivated-organization',
    '/docs/api',
    '/docs/terms',
    '/docs/privacy-policy',
  ];
  if (!getTenantFromUrl()) {
    fullScreenPages.push('/');
  }
  return fullScreenPages;
};

const isNormalPage = (currentPage) => currentPage.indexOf('/settings/forms') >= 0 || (getFullScreenPages().filter((page) => currentPage === page).length === 0 && currentPage.indexOf('/forms') < 0);

export const isMenuShownOnCurrentPage
  = (currentPage) => isNormalPage(currentPage);
